import './barcode-subscriber.css';

import { faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { first } from 'rxjs/operators';
import { Component } from 'vue-property-decorator';

import { input$ } from '../keyboard';
import { CameraScanner, Reader } from './CameraScanner';

declare const CAMERA_SCANNER_ENABLE_ON_COMPATIBLE_DEVICE: boolean;
declare const CAMERA_SCANNER_READERS: Reader[];

@Component({
    template: require('./barcode-subscriber.html'),
})
export class BarcodeSubscriber extends ReactiveVue {
    public lightBulbIcon = faLightbulb;
    public $refs: {
        innerWrapper: HTMLDivElement;
    };

    public value: string = null as any;

    get supportsCamera() {
        return (
            CAMERA_SCANNER_ENABLE_ON_COMPATIBLE_DEVICE &&
            navigator &&
            navigator.mediaDevices &&
            navigator.mediaDevices.getUserMedia
        );
    }

    private cameraScanner = new CameraScanner(CAMERA_SCANNER_READERS);

    public async mounted() {
        if (this.supportsCamera && CAMERA_SCANNER_ENABLE_ON_COMPATIBLE_DEVICE) {
            this.cameraScanner.pipe(first()).subscribe(async code => {
                code.split('').forEach(char => input$.next(char));
                await this.close();
            });
            await this.cameraScanner.start();
        } else {
            this.subscribeToKeyPress();
        }
    }

    public onVideoResize(event) {
        const { videoHeight, videoWidth } = event.target;

        this.$refs.innerWrapper.style.height = `${videoHeight}px`;
        this.$refs.innerWrapper.style.width = `${videoWidth}px`;
    }

    public async close() {
        if (this.supportsCamera) {
            await this.cameraScanner.stop();
            this.$emit('close');
        } else {
            this.unsubscribeFromKeyPress();
        }
    }

    public beforeDestroy() {
        this.unsubscribeFromKeyPress();
    }

    public toggleTorch() {
        this.cameraScanner.toggleTorch();
    }

    private subscribeToKeyPress() {
        window.addEventListener('keypress', this.onKeyPress);
    }

    private unsubscribeFromKeyPress() {
        window.removeEventListener('keypress', this.onKeyPress);
    }

    private onKeyPress = (event: KeyboardEvent) => {
        event.preventDefault();
        input$.next(String.fromCharCode(event.which));
    };
}
